import { SignIn, SignedIn, SignedOut, useUser } from "@clerk/clerk-react";
import { useEffect } from "react";
import { useRoutePath, navigate } from "./lib/router";
import {
  currentPathForRedirect,
  getRedirectFromLocation,
  signInUrlWithReturn,
} from "./lib/redirect";
import { Dashboard } from "./routes/Dashboard";

const SIGN_IN_PATH = "/sign-in";

export function App() {
  const path = useRoutePath();
  const { isSignedIn, isLoaded } = useUser();

  // Auth-driven path sync.
  //
  // - Signed-out user anywhere but /sign-in: bounce to /sign-in with the
  //   current path captured in `?redirect_url=` so the backend's
  //   `createBrowserAuthMiddleware` convention is honored client-side too.
  // - Signed-in user on /sign-in: forward to whatever `?redirect_url=` said
  //   (validated to a same-origin path by safeRedirectTarget).
  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn && path !== SIGN_IN_PATH) {
      navigate(signInUrlWithReturn(currentPathForRedirect()), true);
      return;
    }
    if (isSignedIn && path === SIGN_IN_PATH) {
      navigate(getRedirectFromLocation(), true);
    }
  }, [isLoaded, isSignedIn, path]);

  if (!isLoaded) {
    return (
      <main className="boot-shell">
        <p className="muted">Loading…</p>
      </main>
    );
  }

  return (
    <>
      <SignedOut>
        <AuthLanding />
      </SignedOut>
      <SignedIn>
        <Dashboard />
      </SignedIn>
    </>
  );
}

// Matches the AIF AuthLanding pattern (apps/web/src/App.tsx in
// /Users/michaelinman/Repos/AI-Influencer-Factory): the prebuilt
// <SignIn routing="hash"/> is the only sign-in surface. Clerk handles
// Client Trust, MFA, email-code verification, and password reset
// natively, so the console no longer needs a hand-rolled imperative
// flow that called the Clerk JS API directly.
function AuthLanding() {
  return (
    <main className="auth-shell">
      <section className="auth-panel" aria-labelledby="signInTitle">
        <p className="eyebrow">GHL-Lite</p>
        <h1 id="signInTitle">Console access</h1>
        <p className="auth-copy">
          Sign in with your operator account. Access is granted to accounts that appear in the
          local <code>ghl_console_admins</code> table.
        </p>
        <div className="auth-clerk-mount" aria-label="Sign in">
          <SignIn routing="hash" />
        </div>
      </section>
    </main>
  );
}
